import { Component, Inject, OnInit, Optional } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DiscountService } from '../../../services/DiscountService';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import * as $ from 'jquery';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { AccessKeyUser } from '../../../models/access-key-user';

@Component({
  selector: 'app-access-key-user',
  templateUrl: './access-key-user.component.html',
  styleUrls: ['./access-key-user.component.css']
})
export class AccessKeyUserComponent implements OnInit {  

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any, private UtilityService: UtilityService, public snackBar: MatSnackBar, private GL_MasterService: GL_MasterService) {

     
    if (data != undefined && data.studentID != undefined) {
      this.studentID = data.studentID;
    }
  }
  studentID: string = "";



  userList: any = [];
  accessKeyList: any = [];
  accessKeyUserList: any = [];

  ngOnInit() {
     
    this.UtilityService.getUser().subscribe(users => {
      this.userList = users;
    });

     
    this.UtilityService.getAccessKey().subscribe(items => {
      this.accessKeyList = items;
    });

  }

  selectedFile: File = null;
  onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
    console.log("selected file");
    console.log(this.selectedFile);
  }

  userId: any ;
  onChangeUser($event) {
     
    this.userId = $event.value;
    this.UtilityService.getAccessKeyUser(this.userId).subscribe(items => {
      this.accessKeyUserList = items;
    });
    this.isShow = false;
    this.isAdd = false;
    this.isDelete = false;
    this.isEdit = false;
    this.isMainBranch = false;
    this.isWestBranch = false;
  }

  onChangeUserRefresh() {
    this.UtilityService.getAccessKeyUser(this.userId).subscribe(items => {
      this.accessKeyUserList = items;
    });     
  };

  modelData: AccessKeyUser ={
    accessKeyId :0,
    id : 0,
    isAdd : false,
    isDelete : false,
    isEdit : false,
    isMainBranch : false,
    isShow : false,
    isWestBranch : false,
    userId: "",
    userName: "",
    accessKey: "",
    accessKeyUrl: "",
  };

  //accessKeyId: number = 0;  
  isAdd: boolean = false;
  isDelete: boolean = false;
  isEdit: boolean = false;
  isMainBranch: boolean = false;
  isShow: boolean = false;
  isWestBranch: boolean = false;

  onSubmit(f: NgForm) {
    //console.log(f)
    //console.log(f.value)
    //console.log(this.modelData)    
    if (f.valid) {
      this.modelData = f.value;
       
      this.UtilityService.CreateAccessKeyUser(this.modelData)
        .subscribe(response => {
          this.snackBar.open("دسترسی به کاربر داده شد" , null, {
            duration: 2000,
          }).afterDismissed().subscribe((res)=> {
            this.onChangeUserRefresh();
          });
        },
          error => {
            console.log(error);
            //this.snackBar(null, 'خطا در ثبت
            this.snackBar.open("خطا در ثبت دسترسی", null, {
                duration: 500,
              });
          }
        );
    }
  }

  deleteAccessKey(id: number) {
    if (!confirm("آیا از حذف کردن اطمینان دارید؟"))
      return;

    this.UtilityService.deleteAccessKeyUser(id).subscribe(
      response => {
        this.snackBar.open('دسترسی به این منو حذف شد', '',{
          duration: 500,
        });
      }
    )
  }

  //onSubmit(f: NgForm) {
  //  if (f.valid) {
  //    console.log("Form Validity: " + f.valid);
  //    console.log("Form value : " + f.value['discountFile']);
  //    this.GL_MasterService.getStudentName(f.value["studentID"]).subscribe(a => {
  //      const result = a.json();
  //      if (result["gL_ChildCode"] != null) {
  //        //console.log("student ID: ");
  //        //console.log(a);
  //      } else {
  //        this.snackBar.open("محصل یافت نشد", null, { duration: 5000 });
  //      }
  //    });
  //  } else {
  //    this.snackBar.open("ورودی درست نیست", null, { duration: 5000 });
  //  }
  //}
}



// WEBPACK FOOTER //
// ./src/app/components/settings/access-key-user/access-key-user.component.ts